import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { CustomButton } from "../../../components/CustomButton/CustomButton";
import { CustomToggle } from "../../../components/CustomToggle/CustomToggle";
import { CustomTypography } from "../../../components/CustomTypography/CustomTypography";
import { useNotificationPreferences } from "../../../hooks/useNotificationPreferences";
import useStyles from "./styles";

export const Communication = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { preferences, toggle, save, reset, isDirty, isSaving } =
    useNotificationPreferences();

  const onSave = async () => {
    const ok = await save();
    if (ok) toast.success(t("common.changeSaved", "Change saved"));
  };

  return (
    <div className={classes.divCom}>
      <div className={classes.header}>
        <CustomTypography text={"Communication"} variant={"h3"} isUppercase />
        <CustomTypography
          text={t(
            "setting.communicationSubtitle",
            "Choose which fleet events you want to be notified about."
          )}
          variant={"link"}
          color={"var(--c-muted)"}
        />
      </div>

      <div className={classes.divCom2}>
        {preferences.map((pref) => (
          <div className={classes.divToggle} key={pref.id}>
            <CustomToggle
              isActive={pref.enabled}
              onChange={() => toggle(pref.id)}
              ariaLabel={t(pref.labelKey, pref.defaultLabel)}
            />
            <div className={classes.toggleTexts}>
              <CustomTypography
                text={t(pref.labelKey, pref.defaultLabel)}
                variant={"default"}
                fontWeight="bold"
              />
              <CustomTypography
                text={t(pref.descriptionKey, pref.defaultDescription)}
                variant={"link"}
                color={"var(--c-muted)"}
              />
            </div>
          </div>
        ))}

        <div className={classes.actions}>
          {isDirty && (
            <CustomButton
              label={t("common.cancel", "Cancel")}
              variant={"default"}
              textVariant={"link"}
              fontWeight={"bold"}
              width={"fit-content"}
              height={"40px"}
              onClick={reset}
            />
          )}
          <CustomButton
            label={t("common.saveButton", "Save")}
            variant={isDirty && !isSaving ? "primary" : "disabled"}
            disabled={!isDirty || isSaving}
            loading={isSaving}
            width={"fit-content"}
            height={"40px"}
            onClick={onSave}
          />
        </div>
      </div>
    </div>
  );
};
